import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import PropertiesPage from "../screens/Properties/PropertiesPage";
import LandBank from "../screens/LandBank/LandBank";
import PropertyDetails from "../screens/Investment/Properties/PropertyDetails";

const Stack = createStackNavigator();

const PropertyStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="PropertiesPage" component={PropertiesPage} />
      <Stack.Screen name="LandBank" component={LandBank} />
      <Stack.Screen name="PropertyDetails" component={PropertyDetails} />
    </Stack.Navigator>
  );
};

export default PropertyStackNavigator;
